// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleTestimonial_theme1_container__bIYKH","reviews_wrapper":"SimpleTestimonial_theme1_reviews_wrapper__XDgFK"};